module.exports = __webpack_public_path__ + "img/PKW_Weitverkehrstrupp.b368793f.svg";